import { render, staticRenderFns } from "./DragAndDropCloneList.vue?vue&type=template&id=56895e6e&"
import script from "./DragAndDropCloneList.vue?vue&type=script&lang=js&"
export * from "./DragAndDropCloneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports